import { Box, Typography } from "@mui/material";
import { useWidth } from "../../../../hooks/useResponsive";
import CorporateEventsBannerChef from "../../../../assets/images/b2b/CorporateEventsBannerChef.png";
import CorporateEventsBannerChefWithLogo from "../../../../assets/images/b2b/CorporateEventsBannerChefWithLogo.png";
import YouCaterBusinessLogo from "../../../../assets/images/b2b/YouCaterBusinessLogo.png";
import "./corporateEventsBanner.css";

interface CorporateEventsBannerProps {
	title?: string;
	subtitle?: string;
}

const CorporateEventsBanner = ({
	title = "Corporate Events",
	subtitle = "Corporate Active Events (RFPS)",
}: CorporateEventsBannerProps) => {
	const isMobile = useWidth() === "xs";

	const renderTitle = () => {
		return (
			<>
				<Box className="titleContainer">
					<Typography className="title">{title}</Typography>
					<Typography className="subtitle">{subtitle}</Typography>
				</Box>
				{!isMobile && <Box className="emptyBox" />}
			</>
		);
	};

	return (
		<>
			{isMobile ? (
				<div className="corporateEventsBannerContainer">
					<Box className="mobileBannerContainer">
						<img className="logo" src={YouCaterBusinessLogo} alt="YouCater Business Logo" />
						{renderTitle()}
					</Box>
					<img className="chef" src={CorporateEventsBannerChef} alt="Corporate Events Banner Chef" />
				</div>
			) : (
				<div className="corporateEventsBannerContainer">
					<img
						className="chefWithLogo"
						src={CorporateEventsBannerChefWithLogo}
						alt="Corporate Events Banner Chef With Logo"
					/>
					{renderTitle()}
				</div>
			)}
		</>
	);
};

export default CorporateEventsBanner;
